export default function ($scope, $state, $log, $timeout, addonFactory, DrawpService) {
  DrawpService.gAPageview('about-page', 'About Page', null, null, addonFactory.getActiveAccountEmail());

  $scope.versionLabel = 'v1.310';

  $scope.stateTitle = 'About';
  $scope.backState = 'addonAppIndex';
  $scope.dfsLogoSrc = './assets/homepage/avatar_1660af6dff50_128.jpg';
  $scope.drawpForSchoolLink = 'https://drawpforschool.com';
  $scope.dfsLearnMoreLink =
    'https://forms.zohopublic.com/drawpforschool/form/FreeTrialRequest/formperma/2DH7AkW7cvR0HPRp2vu7vvL5RABVnaBUTMrFf-r90P4';

  $scope.onBackButtonPressed = () => {
    $state.go('addonAppIndex');
  };

  // const getVersionSuffix = () => {
  //   google.script.run
  //     .withSuccessHandler((text) => {
  //       $log.info('Version label suffix fetched successfully.');
  //       if (text.indexOf('app.moondrawp.xyz') >= 0) {
  //         $timeout(() => {
  //           $scope.versionLabel += '-staging';
  //         });
  //       }
  //     })
  //     .getServerUrl();
  // };

  // getVersionSuffix();
};
